import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Drawer } from '@root/shared/ui-kit'

import { unsafeUrlDialogAtom } from '../atoms'

import { UnsafeUrlDialogAnnouncement } from './unsafe-url-dialog-announcement'

export const UnsafeUrlDrawer: React.FC = () => {
  const { t } = useTranslation()
  const [unsafeUrl, setUnsafeUrl] = useAtom(unsafeUrlDialogAtom)
  const handleClose = () => setUnsafeUrl(undefined)

  return (
    <AnimatePresence>
      {unsafeUrl ? (
        <Root
          title={t('unsafe-url-dialog.title')}
          open
          onOpenChange={handleClose}
          backgroundGradient="error"
        >
          <Content>
            <UnsafeUrlDialogAnnouncement
              {...unsafeUrl}
              onClose={handleClose}
              withHeader={false}
            />
          </Content>
        </Root>
      ) : undefined}
    </AnimatePresence>
  )
}

const Root = styled(Drawer)`
  background: var(--background-2);
`

const Content = styled.div`
  padding-bottom: var(--safe-bottom);
`
